import { createContext, useContext } from 'react';
import type { FeedbackInput } from '@/types/feedback';

// The context object and its hook live in a non-component module: a .tsx that
// exports both a component and a hook breaks fast refresh (react-refresh's
// only-export-components).
export interface FeedbackContextValue {
  drugId?: string;
  reportVersion?: number;
  query?: string;
  submitFeedback: (input: FeedbackInput) => Promise<void>;
  submitting: boolean;
}

export const FeedbackContext = createContext<FeedbackContextValue | null>(null);

export function useFeedback(): FeedbackContextValue {
  const ctx = useContext(FeedbackContext);
  if (!ctx) {
    throw new Error('useFeedback must be used within a FeedbackProvider');
  }
  return ctx;
}
